import { View } from 'foundations-components/components/View';
import RecommendationsBasedOnField from '../components/Recommendations/RecommendationsBasedOnField';
import RecommendationsBasedOnProgress from '../components/Recommendations/RecommendationsBasedOnProgress';
import RecommendationsSkeleton from '../components/Recommendations/RecommendationsSkeleton';
import { MlRecommendations, RecommendationsBasedOnInterest, useIsHomepageMLRecommendationsExperimentVariation, usePrioritizeInterestRecommendations, useRecommendations, useRecommendationsTopicPreference } from '../features/recommendations';
import { useSavedLearningInterest, useWizardResults } from '../features/wizard';
import { HasGate } from '../features/accounts/components/HasGate';
import HomePageSection from '../components/Layouts/HomePageSection';
import { useHasGate } from '../features/accounts/accountsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LegacyRecommendationsContainer = () => {
  const {
    prioritizeInterestRecommendations,
    isLoading: prioritizeInterestRecommendationsLoading,
    hasError: prioritizeInterestRecommendationsError
  } = usePrioritizeInterestRecommendations();
  const {
    recommendations: response,
    recommendationsLoading,
    recommendationsError
  } = useRecommendations();
  const {
    recommendations
  } = response || {};
  const hasProgressRecommendations = recommendations && recommendations.length && recommendations[0].recommendationStrategy === 'USER_INTERACTION';
  const savedLearningInterest = useSavedLearningInterest();
  const {
    isRequesting: isLoadingWizardResults,
    error: wizardResultsError
  } = useWizardResults(savedLearningInterest);
  const {
    recommendationsTopicPreferenceLoading
  } = useRecommendationsTopicPreference();
  const {
    hasLearningInterest,
    isLoadingLearningInterest,
    learningInterestError
  } = savedLearningInterest;
  const isRequesting = recommendationsLoading || isLoadingLearningInterest || prioritizeInterestRecommendationsLoading || isLoadingWizardResults || recommendationsTopicPreferenceLoading;
  const error = recommendationsError || learningInterestError || prioritizeInterestRecommendationsError || wizardResultsError;
  return /*#__PURE__*/_jsx("div", {
    "data-loading": isRequesting,
    "data-test-id": "recommendation-cards-container",
    children: isRequesting || error ? /*#__PURE__*/_jsx(RecommendationsSkeleton, {
      error: error
    }) : hasProgressRecommendations && !prioritizeInterestRecommendations ? /*#__PURE__*/_jsx(RecommendationsBasedOnProgress, {}) : hasLearningInterest ? /*#__PURE__*/_jsx(RecommendationsBasedOnInterest, {}) : /*#__PURE__*/_jsx(RecommendationsBasedOnField, {})
  });
};
const RecommendationsContainerWithML = () => {
  const {
    prioritizeInterestRecommendations,
    isLoading: prioritizeInterestRecommendationsLoading,
    hasError: prioritizeInterestRecommendationsError
  } = usePrioritizeInterestRecommendations();
  const isRequesting = prioritizeInterestRecommendationsLoading;
  const error = prioritizeInterestRecommendationsError;

  // no need to render field of interest recommendations as ML recommendations never return blank results
  return /*#__PURE__*/_jsx("div", {
    "data-loading": isRequesting,
    "data-test-id": "recommendation-cards-container",
    children: isRequesting || error ? /*#__PURE__*/_jsx(RecommendationsSkeleton, {
      error: error
    }) : !prioritizeInterestRecommendations ?
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(MlRecommendations, {}) : /*#__PURE__*/_jsx(RecommendationsBasedOnInterest, {})
  });
};
const RecommendationsContainer = () => {
  const isHomepageMLRecommendationsExperimentVariation = useIsHomepageMLRecommendationsExperimentVariation();
  const {
    hasGate: hasInboundCardDesign
  } = useHasGate('Academy:ContentCard:InboundDesign');
  if (isHomepageMLRecommendationsExperimentVariation === null) return null;
  const content = /*#__PURE__*/_jsx(_Fragment, {
    children: isHomepageMLRecommendationsExperimentVariation ? /*#__PURE__*/_jsx(RecommendationsContainerWithML, {}) : /*#__PURE__*/_jsx(LegacyRecommendationsContainer, {})
  });
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: /*#__PURE__*/_jsx(View, {
      marginBlock: "900",
      children: content
    }),
    gate: "Academy:UnifiedAcademy:Navigation",
    children: /*#__PURE__*/_jsx(HomePageSection, {
      marginBlockEnd: hasInboundCardDesign ? '-400' : undefined,
      paddingBlock: "0",
      children: content
    })
  });
};
export default RecommendationsContainer;